import { IApplicationState } from '../../types/redux';

export const selectChat = (state: IApplicationState) => {
  return state.chat;
};
